import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLangSkLangmin = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#a)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9 18a9 9 0 0 0 8.44-12.13H.56A9 9 0 0 0 9 18Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9 18a9.003 9.003 0 0 0 8.44-5.87H.56A9.003 9.003 0 0 0 9 18Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.327 5.087v4.49c0 2.553 3.337 3.336 3.337 3.336S9 12.13 9 9.577v-4.49H2.327Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.11 5.087v4.49c0 .3.066.582.198.848h4.71c.133-.265.2-.549.2-.848v-4.49H3.11Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.229 8.217H6.055v-.783h.783v-.782h-.783v-.783h-.783v.783H4.49v.782h.782v.783H4.098V9h1.174v.782h.783V9h1.174v-.783Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.376 11.518a5.622 5.622 0 0 0 1.288.583 5.623 5.623 0 0 0 1.287-.583c.509-.32.866-.685 1.068-1.093a1.364 1.364 0 0 0-1.101-.215 1.37 1.37 0 0 0-2.508 0 1.371 1.371 0 0 0-1.101.215c.202.408.558.773 1.067 1.093Z",
				fill: "#0052B4"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h18v18H0z"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgLangSkLangmin);
export { ForwardRef as ReactComponent };
